import route from 'ziggy-js';
import React from 'react'
import {Ziggy} from '../ziggy';
import {toast} from "react-toastify";
import {CToaster} from "@coreui/react";

Ziggy.url = window.location.origin;

class Helper {
    route(name, params = undefined, absolute = undefined) {
        return route(name, params, absolute, Ziggy);
    }

    validationErrorToast(res) {
        let finalErrors = `<ul>`;
        Object.keys(res.response.data.errors).map((error) => {
            res.response.data.errors[error].map((inner) => {
                finalErrors += `<li>${inner}</li>`
                toast.error(this.titleCase(inner));
            })
        })
        finalErrors += `<ul/>`
        //future scope
        //toast.error(finalErrors);
    }

    titleCase(str) {
        return str
            .split(' ')
            .map((word) => word[0].toUpperCase() + word.slice(1).toLowerCase())
            .join(' ');
    }

}

export default new Helper();

